import React from "react";
import { observable } from "mobx";
import { observer, inject } from "mobx-react";

import { Grid } from "@material-ui/core";
import { Values } from "Tools/Values";
import SimpleModal from "@src/Components/Common/SimpleModal/SimpleModal";
import ApplicationForm from "../../ApplicationForm/ApplicationForm";
import { IManagementStore } from "Stores/Management/types";
import { IValuesStore } from "Stores/Values/types";
import AddIcon from "@material-ui/icons/Add";
import { ApplicationLink } from "@src/Interfaces/Entity/ApplicationLink";
import { IFile } from "@src/Interfaces/Entity/File";
import RoundButton from "@src/Shared/Components/RoundButton/RoundButton";

interface IProps {
  management?: IManagementStore;
  values?: IValuesStore;
}

@inject("management", "values")
@observer
class AddApplication extends React.Component<IProps> {
  @observable opened: boolean = false;

  handleOpen = () => {
    this.opened = true;
  };

  handleClose = () => {
    this.opened = false;
  };

  handleCreate = async (values: ApplicationLink) => {
    try {
      const newApplication: ApplicationLink = await this.props.management.saveApplicationLink(values, true);
      if (values.fileImage.name === "reset") {
        newApplication.image = this.props.values.common.EmptyId;
        newApplication.imageUrl = "";
      } else if (values.fileImage.name !== "default") {
        const file: IFile = await this.props.management.uploadFile(
          values.fileImage,
          newApplication.id,
          this.props.values.fileTypes.ApplicationImage
        );
        newApplication.image = file.id;
        newApplication.imageUrl = file.url;
      }
      await this.props.management.saveApplicationLink(newApplication);
      this.handleClose();
    } catch (error) {
      console.error(error);
    }
  };

  render() {
    const application = new ApplicationLink();
    return (
      <Grid item>
        <RoundButton
            icon={<AddIcon/>}
            tooltipTitle={Values.getLocalizationValue("add")}
            onClick={() => this.handleOpen()}
            color={"green"}
        />
        
        <SimpleModal
          width={500}
          isOpened={this.opened}
          onClose={this.handleClose}
        >
          <ApplicationForm
            title={Values.getLocalizationValue("Add")}
            initialValues={application}
            onClose={this.handleClose}
            onSubmit={this.handleCreate}
          />
        </SimpleModal>
      </Grid>
    );
  }
}

export default AddApplication;
